import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { SettingsPaths } from "Settings/Routes/Routing";
import { AddCircle } from "@mui/icons-material";
import { Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router";

const userResource = Resources.base.user.roles;

export const UserRolesDefault = () => {
	const { t } = useResource();
	const navigate = useNavigate();

	return (
		<Stack
			spacing={3}
			flexGrow={1}
			height="100%"
			justifyContent="center"
			alignItems="center"
			sx={{ cursor: "pointer" }}
			onClick={() => {
				navigate(SettingsPaths.UsersRolesAdd.route);
			}}
		>
			<Typography variant="h2">{t(userResource.card.subheading)}</Typography>
			<Typography variant="body1">{t(userResource.card.subheading)}</Typography>
			<AddCircle
				fontSize="inherit"
				sx={{ color: useTheme().palette.primary.main }}
			/>
		</Stack>
	);
};
